import { render } from "./DataGraph.vue?vue&type=template&id=674a4e06&scoped=true"
import script from "./DataGraph.vue?vue&type=script&lang=js"
export * from "./DataGraph.vue?vue&type=script&lang=js"

import "./DataGraph.vue?vue&type=style&index=0&id=674a4e06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674a4e06"]])

export default __exports__